"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ThumbnailOverlay;

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

function ThumbnailOverlay(props) {
  var className = props.className,
      style = props.style;
  return _react.default.createElement("div", {
    className: (0, _classNames.default)('thumbnail-overlay', className),
    style: style
  });
}

ThumbnailOverlay.propTypes = {
  className: _react.PropTypes.string,
  style: _react.PropTypes.object
};
module.exports = exports.default;